// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResourceReference } from './ResponseResourceReference';
import {
  ResponseResourceReferenceFromJSON,
  ResponseResourceReferenceFromJSONTyped,
  ResponseResourceReferenceToJSON,
  ResponseResourceReferenceToJSONTyped,
} from './ResponseResourceReference';

/**
 *
 * @export
 * @interface ResponseSkippedResourcesForKind
 */
export interface ResponseSkippedResourcesForKind {
  /**
   *
   * @type {string}
   * @memberof ResponseSkippedResourcesForKind
   */
  group?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseSkippedResourcesForKind
   */
  kind?: string;
  /**
   *
   * @type {Array<ResponseResourceReference>}
   * @memberof ResponseSkippedResourcesForKind
   */
  resources?: Array<ResponseResourceReference>;
  /**
   *
   * @type {string}
   * @memberof ResponseSkippedResourcesForKind
   */
  version?: string;
}

/**
 * Check if a given object implements the ResponseSkippedResourcesForKind interface.
 */
export function instanceOfResponseSkippedResourcesForKind(
  value: object,
): value is ResponseSkippedResourcesForKind {
  return true;
}

export function ResponseSkippedResourcesForKindFromJSON(
  json: any,
): ResponseSkippedResourcesForKind {
  return ResponseSkippedResourcesForKindFromJSONTyped(json, false);
}

export function ResponseSkippedResourcesForKindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseSkippedResourcesForKind {
  if (json == null) {
    return json;
  }
  return {
    group: json['group'] == null ? undefined : json['group'],
    kind: json['kind'] == null ? undefined : json['kind'],
    resources:
      json['resources'] == null
        ? undefined
        : (json['resources'] as Array<any>).map(
            ResponseResourceReferenceFromJSON,
          ),
    version: json['version'] == null ? undefined : json['version'],
  };
}

export function ResponseSkippedResourcesForKindToJSON(
  json: any,
): ResponseSkippedResourcesForKind {
  return ResponseSkippedResourcesForKindToJSONTyped(json, false);
}

export function ResponseSkippedResourcesForKindToJSONTyped(
  value?: ResponseSkippedResourcesForKind | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    group: value['group'],
    kind: value['kind'],
    resources:
      value['resources'] == null
        ? undefined
        : (value['resources'] as Array<any>).map(
            ResponseResourceReferenceToJSON,
          ),
    version: value['version'],
  };
}
